import axios from 'axios';

const api = axios.create({
    baseURL: process.env.VUE_APP_API_VERIFACTU
});

const bearerToken = {
    Authorization: 'Bearer 1|vQgHiuW1c2hDCnRGRW85Pyjx6CgisDPLMXpdIRktd5ce1fb5',
    Accept: 'application/json',
    'Content-Type': 'application/json',
};

export default {
    async getRegistrosVerifactu(empresa) {
        try {
            const response = await api.get(`companies/${empresa}/registros`, {
                headers: bearerToken,
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
}